import { FieldShell } from './FieldShell';
import { FieldSelect } from './FieldSelect';
import { useDomFieldId } from './_useFieldName';

const BLOCK = 'LStudio__app_field';

/*
    🔥 MES Y AÑO

    Para vencimientos, reportes y períodos. El valor es { month, year }
    con el mes en base 1 (enero = 1), que es como lo espera un backend.
*/

const MONTHS = [
    'Enero', 'Febrero', 'Marzo', 'Abril', 'Mayo', 'Junio',
    'Julio', 'Agosto', 'Septiembre', 'Octubre', 'Noviembre', 'Diciembre',
];

export const FieldMonthYear = ({
    id, label, hint, error,
    value = {}, onChange,
    yearFrom = null, yearTo = null,
    isRequired = false, isDisabled = false, span = 1,
}) => {

    const NOW = new Date().getFullYear();

    const FROM = yearFrom ?? NOW - 5;
    const TO = yearTo ?? NOW + 5;

    const YEARS = Array.from({ length: TO - FROM + 1 }, (_, i) => FROM + i);

    const onSet = (key) => (event) => onChange?.({ ...value, [key]: Number(event.target.value) });

    const DOM_ID = useDomFieldId(id);

    return (
        <FieldShell id={DOM_ID} label={label} hint={hint} error={error}
            isRequired={isRequired} isDisabled={isDisabled} span={span} >

            <div className={`${BLOCK}__monthyear`}>

                <div className={`${BLOCK}__monthyear_select`}>
                    <FieldSelect isBare id={DOM_ID} value={value.month ?? ''}
                        options={MONTHS.map((m, i) => ({ value: i + 1, label: m }))}
                        placeholder="Mes" onChange={onSet('month')}
                        isDisabled={isDisabled} isRequired={isRequired} isSearchable={false} />
                </div>

                <div className={`${BLOCK}__monthyear_select`}>
                    <FieldSelect isBare value={value.year ?? ''}
                        options={YEARS.map((y) => ({ value: y, label: String(y) }))}
                        placeholder="Año" onChange={onSet('year')}
                        isDisabled={isDisabled} isRequired={isRequired} isSearchable={false} />
                </div>

            </div>

        </FieldShell>
    );
};
